<template>
  <div>
    <el-row>
        <el-col :span="4">
            <!-- 面包屑导航 -->
            <el-page-header size="mini" @back="back" style="padding: 10px 0;" :content="title">
            </el-page-header>
        </el-col>
        <el-col :span="12" :offset="4">
            <h3 class="redStyle">请上传小于4M的清晰图片，或者打开图片后截图</h3>
        </el-col>
    </el-row>

    <!-- 卡片 -->
    <el-card class="box-card">

      <el-tabs v-model="activeName" @tab-click="handleClick">

        <el-tab-pane label="主车信息" name="first">
          <el-form
              :inline="true"
              :model="addForm"
              ref="addForm"
              :rules="rules"
              autocomplete="on"
              size="small"
              label-width="120px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="uploadFile" action="#">
                <i class="el-icon-upload" v-if="!addForm.file_url">
              <span class="fontStyle1">将行驶证拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
                </i>
                <div class="uploaded" v-else :style="{'background-image': 'url(' + addForm.file_url + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}">
<span class="fontStyle3">
                <i class="el-icon-zoom-in" @click="openWin('../../static/typeImg.html?typeImage=' +addForm.file_url)">查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg(1)">删除图片</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
</span>

                </div>

              </el-upload>
            </el-col>
            <el-col :span="8">
              <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImage" action="#">
                <i class="el-icon-upload" v-if="!addForm.cardImageUrl">
              <span class="fontStyle1">将车主身份证拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
                </i>
                <div class="uploaded" v-else :style="{'background-image': 'url(' + addForm.cardImageUrl + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}">
<span class="fontStyle3">
                <i class="el-icon-zoom-in" @click="openWin('../../static/typeImg.html?typeImage=' +addForm.cardImageUrl)">查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg(2)">删除图片</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
</span>

                </div>

              </el-upload>
            </el-col>
            <el-col :span="8">
              <el-form-item label="车主姓名">
                <el-input v-model="addForm.username" type="text"></el-input>
              </el-form-item>
              <el-form-item label="身份证号">
                <el-input v-model="addForm.card" type="text"></el-input>
              </el-form-item>
              <el-form-item label="手机号">
                <el-input v-model="addForm.mobile" type="text"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24" style=" padding-top: 10px;">
          <el-col :span="8">
           <el-form-item label="所有人" prop="allPerson">
             <el-input v-model="addForm.allPerson" type="text"></el-input>
           </el-form-item>
         </el-col>
              <el-col :span="8">
                  <el-form-item label="核定载人数">
                      <el-input v-model="addForm.seating_capacity" type="text"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="8">
                  <el-form-item label="发证单位">
                      <el-input v-model="addForm.unit" type="text"></el-input>
                  </el-form-item>
              </el-col>


      </el-row>

      <el-row :gutter="24">
          <el-col :span="8">
              <el-form-item label="号牌号码" prop="plate_number">
                  <el-input v-model="addForm.plate_number" type="text">
                  </el-input>
              </el-form-item>
          </el-col>
          <el-col :span="8">
              <el-form-item label="车辆类型" prop="vehicle_type">
                  <el-input v-model="addForm.vehicle_type" type="text"></el-input>
              </el-form-item>
          </el-col>
          <el-col :span="8">
              <el-form-item label="档案编号">
                  <el-input v-model="addForm.file_no" type="text"></el-input>
              </el-form-item>
          </el-col>



      </el-row>
        <el-row :gutter="24">
        <el-col :span="8" >
          <el-form-item label="品牌型号">
            <el-input v-model="addForm.model" type="text"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="注册日期">
            <el-input v-model="addForm.register_date" type="text"></el-input>
          </el-form-item>
        </el-col>
            <el-col :span="8">
                <el-form-item label="总质量">
                    <el-input v-model="addForm.total_mass" type="text"></el-input>
                </el-form-item>
            </el-col>

      </el-row>
      <el-row :gutter="24">
          <el-col :span="8">
              <el-form-item label="车架号" prop="vin">
                  <el-input v-model="addForm.vin" type="text"></el-input>
              </el-form-item>
          </el-col>

          <el-col :span="8" >
              <el-form-item label="发证日期">
                  <el-input v-model="addForm.issue_date" type="text"></el-input>
              </el-form-item>
          </el-col>
          <el-col :span="8">
              <el-form-item label="燃油类型">
                  <el-input v-model="addForm.fuel_type" type="text"></el-input>
              </el-form-item>
          </el-col>
      </el-row>
      <el-row :gutter="24">

          <el-col :span="8">
              <el-form-item label="发动机号码">
                  <el-input v-model="addForm.engine_number" type="text"></el-input>
              </el-form-item>
          </el-col>
          <el-col :span="8">
              <el-form-item label="外廓尺寸">
                  <el-input v-model="addForm.out_to_out" type="text"></el-input>
              </el-form-item>
          </el-col>
          <el-col :span="8">
              <el-form-item label="证芯编号">
                  <el-input v-model="addForm.core_no" type="text"></el-input>
              </el-form-item>
          </el-col>
      </el-row>
<!--        <el-row :gutter="24">-->
<!--        <el-col :span="8">-->
<!--          <el-form-item label="检验记录">-->
<!--            <el-input v-model="addForm.record" type="text"></el-input>-->
<!--          </el-form-item>-->
<!--        </el-col>-->

<!--        <el-col :span="8">-->
<!--          <el-form-item label="核定载质量">-->
<!--            <el-input v-model="addForm.approved_load" type="text"></el-input>-->
<!--          </el-form-item>-->
<!--        </el-col>-->
<!--      </el-row>-->


        <el-row>
            <el-col :span="8">
                <el-form-item label="整备质量">
                    <el-input v-model="addForm.curb_weight" type="text"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="准牵引总质量">
                    <el-input v-model="addForm.traction_mass" type="text"></el-input>
                </el-form-item>
            </el-col>

            <el-col :span="8">
                <el-form-item label="备注">
                    <el-input v-model="addForm.remark" type="text"></el-input>
                </el-form-item>
            </el-col>


      </el-row>
      <el-row :gutter="24">
          <el-col :span="8">
              <el-form-item label="使用性质">
                  <el-input v-model="addForm.use_character" type="text"></el-input>
              </el-form-item>
          </el-col>
          <el-col :span="16">
              <el-form-item label="地址" style="width:100%;">
                  <el-input v-model="addForm.address" type="textarea" style="width:600px;" :autosize="{minRow: 1, maxRow: 1}"></el-input>
              </el-form-item>
          </el-col>
      </el-row>
      <el-row>



      </el-row>

          <el-row :gutter="24">
            <el-col style="display:flex;flex-direction: row;justify-content: flex-end">
              <el-form-item>
                <el-button @click="close">取消</el-button>
                <el-button type="primary" @click="save('addForm')">保存</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          </el-form>
      </el-tab-pane>
        <el-tab-pane label="主车大本信息" name="second">
          <car-big-book :child-data="this.addForm.id" @update-parent-data="updateParentData"></car-big-book>
        </el-tab-pane>
      <el-tab-pane label="挂车大本信息" name="third">
            <car-trailer-info :child-data="this.addForm.id" @update-parent-data="updateParentData"></car-trailer-info>
      </el-tab-pane>

        <el-tab-pane label="营运证信息" name="four">
          <car-trad :child-data="this.addForm.id" @update-parent-data="updateParentData"></car-trad>
        </el-tab-pane>
        <el-tab-pane label="驾驶员三证" name="five">
          <car-drive :child-data="this.addForm.id" @update-parent-data="updateParentData"></car-drive>
        </el-tab-pane>
        <el-tab-pane label="附件信息" name="six">
          <car-other :child-data="this.addForm.id" @update-parent-data="updateParentData"></car-other>
        </el-tab-pane>
      </el-tabs>


    </el-card>
    <!-- 全局遮罩 图片上传 -->
    <el-dialog :visible.sync="dialogVisible" :modal="true" :close-on-click-modal="false" :close-on-press-escape="false" width="50%">
      <div class="loading-overlay">
        <div class="loading-spinner" style="font-size:30px;font-weight: bold">
          <i class="el-icon-upload"></i>
          图片上传ing
          <i class="el-icon-loading"></i>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import eTable from "../common/eTable.vue";
  import moment from 'moment'     //日期时间转换
  import imgCompressUtil from "../../utils/imgCompressUtil";
  import CarTrailerInfo from "../common/carTrailerInfo";
  import CarTrad from "../common/carTrad";
  import CarDrive from "../common/carDrive";
  import CarBigBook from "../common/carBigBook";
  import CarOther from "../common/carOther";

  export default {
    name: "carForm",
    components: {
      CarOther,
      CarBigBook,
      CarDrive,
      CarTrad,
      CarTrailerInfo,
      eTable
    },
    props: {},
    data() {
      return {
        dialogVisible: false,
        overlayClass: 'loading-overlay', // 遮罩元素的类名
        // 搜索
        activeName: 'first',
        searchForm: {
          name: '',
          credit_code:''
        },
        shopList:'',
        addForm:{
          id:'',
          cardImageUrl:'',
          plate_number:'',
          allPerson:'',
          unit:'',
          engine_number:'',
          use_character:'',
          address:'',
          issue_date:'',
          model1:'',
          model:'',
          register_date:'',
          vehicle_type:'',
          vin:'',
          record:'',
          seating_capacity:'',
          approved_load:'',
          curb_weight:'',
          out_to_out:'',
          total_mass:'',
          fuel_type:'',
          traction_mass:'',
          remark:'',
          file_no:'',
          operator_id:sessionStorage.getItem('user_id'),
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          shop_id:sessionStorage.getItem('shop_id'),
          file_url:'',
          is_main:'1',
          trailer_plate_number:'',
          username:'',
          card:'',
          mobile:'',
          core_no:'',
        },

        id: '',
        rules: {
          plate_number: [{ required: true, message: '请输入号牌号码', trigger: 'blur' }],
          allPerson: [{ required: true, message: '请输入所有人', trigger: 'blur' }],
          shop_id: [{ required: true, message: '请选择运输公司', trigger: 'blur' }],
          vin: [{ required: true, message: '请输入车辆识别代号', trigger: 'blur' }],
          vehicle_type: [{ required: true, message: '请输入车辆类型', trigger: 'blur' }],
        },

        title: '车辆档案新增',

        uploadImg: '',
        address:'',
        parentData:''
      };
    },
    created() {
      //this.shopList=JSON.parse(sessionStorage.getItem('shopList'));
      this.getShopList()
      var id= this.$route.query.id;
      if(isNaN(id)&&id!=null&&id!=''){
        this.title = '车辆档案编辑'
        this.addForm.id=id;
         this.getOne();
     }
    },
    mounted() {},
    filters: {

      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
      },

    },
    methods: {
      //获取运输公司
      getShopList() {
        let param = {
          company_id: this.addForm.company_id,
          access_token: this.addForm.access_token,
          page:1,
          pageSize:1000,
          show_type:1
        }
        this.$axios.shopGetShopList(param).then(res =>{
          if(res.code == 200){
            this.shopList = res.data.data;
          }else{
            this.$message.error(res.msg);
          }
        })
      },
      getOne(){
        let param = {
          id:this.addForm.id,
          company_id:this.addForm.company_id,
          access_token:this.addForm.access_token
        };
        this.$axios.carInfo(param).then(res =>{
          if(res.code == 200){
            this.addForm=res.data
            // this.addForm.model1=res.data.model;
          }else{
            this.$message.error(res.msg);
          }
        })
      },
      handleClick(){

      },
      handleBeforeUpload(){
         //console.log('before?')
      },
      uploadSuccess(response, file, fileList) {
        // 上传成功后，重置el-upload组件
        this.$refs.upload.clearFiles();
        this.fileList = fileList;
        //console.log('88888------',item.raw)
      },
      uploadFile(item){
        let _this=this;
        this.addForm.file_url = URL.createObjectURL(item.raw);
        let file = item.raw;
        _this.addForm.file_url=item.raw;
        _this.dialogVisible = true;
        this.getBase64(item.raw).then(res => {
         // //console.log('base64--------',res);
                const params = {
                  company_id:sessionStorage.getItem('company_id'),
                  access_token:sessionStorage.getItem('token'),
                }
                  //行驶证识别
                  this.$axios.getAccessToken(params).then(res1=>{
                        ////console.log('baidu token----',res1)
                        let access_token=res1.data.access_token;
                       ////console.log('baidu access_token----',access_token)
                    sessionStorage.setItem('access_token',access_token);

                    imgCompressUtil.compressImg(file).then((res3) => {
                      let param={
                        image: res3.replace(/^data:image\/\w+;base64,/, '')//encodeURIComponent(res3),
                        // detect_direction:'true',
                        // vehicle_license_side:'true',
                        // unified:'true',
                        // quality_warn:'true'
                      };
                      let shopFd = new FormData()
                      shopFd.append('image', res3.replace(/^data:image\/\w+;base64,/, ''))

                      this.$axios.getOCRVehicleLicense(shopFd).then(res2=>{

                        _this.addForm.plate_number= res2.words_result.号牌号码.words;
                        _this.addForm.allPerson= res2.words_result.所有人.words;
                        _this.addForm.unit= res2.words_result.发证单位.words;
                        _this.addForm.engine_number= res2.words_result.发动机号码.words;
                        _this.addForm.use_character= res2.words_result.使用性质.words;
                        _this.addForm.address= res2.words_result.住址.words;
                        this.address = res2.words_result.住址.words;
                        _this.addForm.issue_date= res2.words_result.发证日期.words;
                        _this.addForm.model= res2.words_result.品牌型号.words;
                        _this.addForm.register_date= res2.words_result.注册日期.words;
                        _this.addForm.vehicle_type= res2.words_result.车辆类型.words;
                        _this.addForm.vin= res2.words_result.车辆识别代号.words;

                        //todo start 查看下是否需要保留
                        if(this.addForm.allPerson){
                           this.shopList.find((item)=>{
                             if(item.name==this.addForm.allPerson){
                                this.addForm.shop_id=item.id;
                             }
                           });
                        }
                        //todo end
                        //根据运输公司名称查询运输公司信息 没有 用 this.address
                        // if(_this.addForm.allPerson)
                        // {
                        //   const paramShop = {
                        //     company_id:sessionStorage.getItem('company_id'),
                        //     access_token:sessionStorage.getItem('token'),
                        //     name:_this.addForm.allPerson
                        //   }
                        //   this.$axios.getShopInfoByName(paramShop).then(resS=>{
                        //     if(resS.data.address)
                        //        _this.addForm.address = resS.data.address
                        //     else
                        //       resS.data.address = this.address
                        //     //console.log('运输公司信息',resS)
                        //   });
                        // }else{
                        //   _this.addForm.address = this.address
                        // }
                        let param_back = new FormData()
                        param_back.append('image', res3.replace(/^data:image\/\w+;base64,/, ''));
                        param_back.append('vehicle_license_side', 'back');
                        this.getBackOCRVehicleLicense(param_back);

                        //------上传到阿里云
                        let carFd = new FormData()
                        carFd.append('file', item.raw)
                        carFd.append('img_type', 1)
                        carFd.append('company_id', sessionStorage.getItem('company_id'))
                        carFd.append('access_token', sessionStorage.getItem('token'))
                        this.$axios.carUploadImage(carFd).then(res11 => {
                          if (res11.code == 200) {
                            this.$message.success(res11.msg)
                            this.addForm.file_url = res11.data.src;
                            this.dialogVisible = false;
                          } else if (res11.code == 1) {
                            this.$message.error(res11.msg)
                          }
                        }).catch(function (error) {
                          //console.log(error);
                        })
                        //------上传到阿里云
                      });
                     });
                  })
                 //行驶证识别
        });

      },
      getBackOCRVehicleLicense(param_back){
        let _this=this;
        this.$axios.getOCRVehicleLicense(param_back).then(res2=>{
          if(res2.words_result!=undefined){

            _this.addForm.record= res2.words_result!=undefined?res2.words_result.检验记录.words:'';
            _this.addForm.approved_load= res2.words_result.核定载质量.words;
            _this.addForm.curb_weight= res2.words_result.整备质量.words;
            _this.addForm.out_to_out= res2.words_result.外廓尺寸.words;
            _this.addForm.seating_capacity= res2.words_result.核定载人数.words;
            _this.addForm.total_mass= res2.words_result.总质量.words;
            _this.addForm.fuel_type= res2.words_result.燃油类型.words;
            _this.addForm.traction_mass= res2.words_result.准牵引总质量.words;
            _this.addForm.remark= res2.words_result.备注.words;
            _this.addForm.file_no= res2.words_result.档案编号.words;
            //_this.addForm.vin= res2.words_result.号牌号码.words;
            _this.addForm.core_no= res2.words_result.证芯编号.words;
            //console.log('getOCRVehicleLicense token----',res2)


          }else{
            this.$message.error("行驶证副页面识别错误")

          }
        });
      },

      getBase64(file) {
        return new Promise(function(resolve, reject)
        {let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function() {imgResult = reader.result;};
        reader.onerror = function(error) {reject(error);};
        reader.onloadend = function() {resolve(imgResult);};});
      },
      back(){
        this.$router.back();
      },
      save(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let param={
            id:this.addForm.id,
            plate_number:this.addForm.plate_number,
            allPerson:this.addForm.allPerson,
            unit:this.addForm.unit,
            engine_number:this.addForm.engine_number,
            use_character:this.addForm.use_character,
            address:this.addForm.address,
            issue_date:this.addForm.issue_date,
            model:this.addForm.model,
            register_date:this.addForm.register_date,
            vehicle_type:this.addForm.vehicle_type,
            vin:this.addForm.vin,
            record:this.addForm.record,
            seating_capacity:this.addForm.seating_capacity,
            approved_load:this.addForm.approved_load,
            curb_weight:this.addForm.curb_weight,
            out_to_out:this.addForm.out_to_out,
            total_mass:this.addForm.total_mass,
            fuel_type:this.addForm.fuel_type,
            traction_mass:this.addForm.traction_mass,
            remark:this.addForm.remark,
            file_no:this.addForm.file_no,
            operator_id:sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            shop_id:this.addForm.shop_id,
            cardImageUrl:this.addForm.cardImageUrl,
            file_url:this.addForm.file_url,
            username:this.addForm.username,
            card:this.addForm.card,
            mobile:this.addForm.mobile,
            is_main:this.addForm.is_main,
            trailer_plate_number:this.addForm.trailer_plate_number,
              core_no:this.addForm.core_no

            };
            //console.log('save------',param);
            this.$axios.saveCar(param).then(res =>{
              if(res.code == 200){
                this.addForm.id = res.data.id;
                this.$message.success(res.msg)
                 this.$router.push('/carList')
              }else{
                this.$message.error(res.msg);
              }
            })
          }
        });


      },
      close(){

      },

      updateParentData(newData) {
        this.parentData = newData;
      },
      //上传图片的方法
      UploadImage(file) {
        let _this=this;
        _this.dialogVisible = true;
        this.addForm.cardImageUrl = URL.createObjectURL(file.raw);
        //console.log('UploadImage-file',file)
        let payFd = new FormData()
        payFd.append('file', file.raw)
        payFd.append('img_type', 3)
        payFd.append('company_id', sessionStorage.getItem('company_id'))
        payFd.append('access_token', sessionStorage.getItem('token'))
        this.$axios.carUploadImage(payFd).then(res => {
          if (res.code == 200) {
            _this.addForm.cardImageUrl = res.data.src;
            this.$message.success(res.msg)
            _this.dialogVisible = false;
          }else{
            this.$message.error(res.msg)
          }
        }).catch(error => console.log('UploadImage-error',error))

      },
      openWin(url) {
        var name;                           //网页名称，可为空;
        var iWidth = 500;                         //弹出窗口的宽度;
        var iHeight = 570;                        //弹出窗口的高度;
        //window.screen.height获得屏幕的高，window.screen.width获得屏幕的宽
        var iTop = (window.screen.height - 30 - iHeight) / 2;       //获得窗口的垂直位置;
        var iLeft = (window.screen.width - 10 - iWidth) / 2;        //获得窗口的水平位置;
        window.open(url, name, 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',toolbar=no,menubar=no,scrollbars=auto,resizable=no,location=no,status=no');
      },
      delImg(type){
        if(type==2){
          this.addForm.cardImageUrl = '';
        }else if(type==1){
          this.addForm.file_url = '';
        }
      },
    },
  };
</script>
<style>
  .upload-demo{display: flex;flex-direction: row;justify-content: flex-start;align-items: center;}
  .el-page-header__content{font-size:14px !important;}
  .table_name{
    font-weight: bold;
    /* border: 1px solid #f00; */
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
  .lbs .el-form-item__label{
    color:#409EFF;
  }
  img.uploadImg{
    width: 180px;max-height: 180px;margin-left: 20px;border-radius: 5px;
  }
  .fontStyle1{
    display: block;
    font-size:14px;
    color: #606266;
  }
  .fontStyle2,.fontStyle3{
    font-size:14px;
    color: #3a8ee6;
  }
  .fontStyle3{
    font-size:22px;
    color: #999;
    position: absolute;
    bottom: 1px;
    right: 1px;
  }
  .redStyle{
      color: #f56c6c;
  }
</style>



// WEBPACK FOOTER //
// src/view/car/carForm.vue